// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__21UMm","item":"PaymentsMobile_item__1KYcJ","label":"PaymentsMobile_label__1pRlY","amount":"PaymentsMobile_amount__1c_3o"};